// extracted by mini-css-extract-plugin
export default {"avatarContainer":"avatar_avatarContainer__m2WRM","placeholder":"avatar_placeholder__A30zG","placeholderSpan":"avatar_placeholderSpan__B-fDG"};